'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationCallSplit = function CommunicationCallSplit(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z' })
  );
};
CommunicationCallSplit = (0, _pure2.default)(CommunicationCallSplit);
CommunicationCallSplit.displayName = 'CommunicationCallSplit';
CommunicationCallSplit.muiName = 'SvgIcon';

exports.default = CommunicationCallSplit;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/communication/call-split.js
// module id = 1193
// module chunks = 0